<template>
  <div class="new-page-con new-layout-con-news">
    <!-- <Header></Header> -->
    <Home></Home>
  </div>
</template>

<script>
import Header from "@/views/newLayout/header.vue";
import Home from "@/views/newLayout/home.vue";
export default {
  components: {
    Header,
    Home,
  },
  data() {
    return {};
  },
};
</script>
